import React from 'react'
import { ContainerOptions, Option } from '../../../components/ag-grid-utils/styles'
import PropTypes from 'prop-types'
import AuthService from '../../../services/auth-service/AuthService'

DeleteLink.propTypes = {
    data: PropTypes.object,
    context: PropTypes.object,
}

export default function DeleteLink(props) {
    const isDeleteAvailable = AuthService.getDecodedToken().scopes.filter(scope => scope === 'delete_role').length > 0
    const isEditAvailable = AuthService.getDecodedToken()?.scopes.filter(scope => scope === 'edit_role').length > 0

    const askToDeleteRole = role => {
        if (isDeleteAvailable) {
            props.context.askToDeleteRole(role)
        }
    }

    const selectRole = role => {
        if (isEditAvailable) {
            props.context.selectRoleToEdit(role)
        }
    }

    return (
        <ContainerOptions className="cypress--action-menu">
            <Option
                className="cy--delete-role"
                avaiable={isDeleteAvailable}
                onClick={() => askToDeleteRole(props.data)}
            >
                Remover
            </Option>
            &nbsp; &nbsp;
            <Option avaiable={isEditAvailable} onClick={() => selectRole(props.data)}>
                Editar
            </Option>
        </ContainerOptions>
    )
}
